<img src="assets/images/icons/state-empty.svg" class="img" alt="">
<div class="text">
  <ng-content></ng-content>
</div>